"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.5.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfVariantSuggestionRequest = instanceOfVariantSuggestionRequest;
exports.VariantSuggestionRequestFromJSON = VariantSuggestionRequestFromJSON;
exports.VariantSuggestionRequestFromJSONTyped = VariantSuggestionRequestFromJSONTyped;
exports.VariantSuggestionRequestToJSON = VariantSuggestionRequestToJSON;
exports.VariantSuggestionRequestToJSONTyped = VariantSuggestionRequestToJSONTyped;
const cardUsedInVariantSuggestionRequest_1 = require("./cardUsedInVariantSuggestionRequest");
const featureProducedInVariantSuggestionRequest_1 = require("./featureProducedInVariantSuggestionRequest");
const templateRequiredInVariantSuggestionRequest_1 = require("./templateRequiredInVariantSuggestionRequest");
/**
 * Check if a given object implements the VariantSuggestionRequest interface.
 */
function instanceOfVariantSuggestionRequest(value) {
    if (!('uses' in value) || value['uses'] === undefined)
        return false;
    if (!('requires' in value) || value['requires'] === undefined)
        return false;
    if (!('produces' in value) || value['produces'] === undefined)
        return false;
    if (!('description' in value) || value['description'] === undefined)
        return false;
    return true;
}
function VariantSuggestionRequestFromJSON(json) {
    return VariantSuggestionRequestFromJSONTyped(json, false);
}
function VariantSuggestionRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'uses': (json['uses'].map(cardUsedInVariantSuggestionRequest_1.CardUsedInVariantSuggestionRequestFromJSON)),
        'requires': (json['requires'].map(templateRequiredInVariantSuggestionRequest_1.TemplateRequiredInVariantSuggestionRequestFromJSON)),
        'produces': (json['produces'].map(featureProducedInVariantSuggestionRequest_1.FeatureProducedInVariantSuggestionRequestFromJSON)),
        'variantOf': json['variantOf'] == null ? undefined : json['variantOf'],
        'manaNeeded': json['manaNeeded'] == null ? undefined : json['manaNeeded'],
        'easyPrerequisites': json['easyPrerequisites'] == null ? undefined : json['easyPrerequisites'],
        'notablePrerequisites': json['notablePrerequisites'] == null ? undefined : json['notablePrerequisites'],
        'description': json['description'],
        'spoiler': json['spoiler'] == null ? undefined : json['spoiler'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}
function VariantSuggestionRequestToJSON(json) {
    return VariantSuggestionRequestToJSONTyped(json, false);
}
function VariantSuggestionRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'uses': (value['uses'].map(cardUsedInVariantSuggestionRequest_1.CardUsedInVariantSuggestionRequestToJSON)),
        'requires': (value['requires'].map(templateRequiredInVariantSuggestionRequest_1.TemplateRequiredInVariantSuggestionRequestToJSON)),
        'produces': (value['produces'].map(featureProducedInVariantSuggestionRequest_1.FeatureProducedInVariantSuggestionRequestToJSON)),
        'variantOf': value['variantOf'],
        'manaNeeded': value['manaNeeded'],
        'easyPrerequisites': value['easyPrerequisites'],
        'notablePrerequisites': value['notablePrerequisites'],
        'description': value['description'],
        'spoiler': value['spoiler'],
        'comment': value['comment'],
    };
}
//# sourceMappingURL=variantSuggestionRequest.js.map